import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 512 512" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path d="M441.412 140.235v338.781c0 18.219-14.778 32.983-32.983 32.983H103.572c-18.219 0-32.983-14.764-32.983-32.983V32.983C70.588 14.764 85.352 0 103.572 0h197.605l140.235 140.235z" fill="#28b446"/>
        <path fill="#219b38" d="M320.31 137.188l121.102 49.891v-46.844l-68.661-20.273z"/>
        <path d="M441.412 140.235H334.16c-18.22 0-32.983-14.764-32.983-32.983V0l140.235 140.235z" fill="#6ace7c"/>
        <path d="M337.115 254.946H174.876c-5.82 0-10.536 4.717-10.536 10.536v141.169c0 5.818 4.716 10.536 10.536 10.536h162.239c5.82 0 10.536-4.717 10.536-10.536V265.482c0-5.818-4.716-10.536-10.536-10.536zm-151.703 67.736h60.048v26.773h-60.048v-26.773zm81.119 0h60.048v26.773h-60.048v-26.773zm60.049-21.071h-60.048v-25.593h60.048v25.593zm-81.12-25.593v25.592h-60.048v-25.592h60.048zm-60.048 94.508h60.048v25.592h-60.048v-25.592zm81.119 25.591v-25.592h60.048v25.592h-60.048z" fill="#fff"/>
    </svg>
)

export default class IconGoogleSpreasheets extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
